var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Container, Paper, Typography, Box, Alert, CircularProgress, Divider, AppBar, Toolbar, Link, Button, TextField } from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword } from 'firebase/auth';
import GoogleIcon from '@mui/icons-material/Google';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import { auth } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';
export default function Auth() {
    var _this = this;
    var _a;
    var _b = useState(''), error = _b[0], setError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(''), email = _d[0], setEmail = _d[1];
    var _e = useState(''), password = _e[0], setPassword = _e[1];
    var _f = useState(''), statusMessage = _f[0], setStatusMessage = _f[1];
    var navigate = useNavigate();
    var currentUser = useAuth().currentUser;
    var location = useLocation();
    var from = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.from) || '/model';
    // If user is already authenticated, redirect to intended destination
    useEffect(function () {
        if (currentUser) {
            console.log('User authenticated, redirecting to:', from);
            navigate(from, { replace: true });
        }
    }, [currentUser, navigate, from]);
    var handleGoogleSignIn = function () { return __awaiter(_this, void 0, void 0, function () {
        var provider, result, error_1, authError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setError('');
                    setLoading(true);
                    setStatusMessage('Opening Google sign-in popup...');
                    provider = new GoogleAuthProvider();
                    provider.setCustomParameters({
                        prompt: 'select_account'
                    });
                    return [4 /*yield*/, signInWithPopup(auth, provider)];
                case 1:
                    result = _a.sent();
                    console.log('Google sign-in successful:', result.user.email);
                    setStatusMessage('Sign-in successful! Redirecting...');
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error('Google auth error:', error_1);
                    authError = error_1;
                    if (authError.code === 'auth/popup-blocked') {
                        setError('Please allow popups for this site to sign in with Google');
                    }
                    else if (authError.code === 'auth/popup-closed-by-user') {
                        setError('Sign-in cancelled. Please try again.');
                    }
                    else {
                        setError(authError.message || 'Authentication failed');
                    }
                    setStatusMessage('');
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleLogin = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var error_2, authError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setStatusMessage('Signing in...');
                    setLoading(true);
                    setError('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, signInWithEmailAndPassword(auth, email, password)];
                case 2:
                    _a.sent();
                    setStatusMessage('Sign-in successful! Redirecting...');
                    navigate(from, { replace: true });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    authError = error_2;
                    if (authError.code === 'auth/invalid-email') {
                        setError('Invalid email address');
                    }
                    else if (authError.code === 'auth/wrong-password') {
                        setError('Incorrect password');
                    }
                    else if (authError.code === 'auth/user-not-found') {
                        setError('No account found with this email');
                    }
                    else {
                        setError(authError.message || 'Authentication failed');
                    }
                    setStatusMessage('');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(AppBar, { position: "static", color: "transparent", elevation: 0, children: _jsxs(Toolbar, { children: [_jsx(PrecisionManufacturingIcon, { sx: { mr: 2 } }), _jsx(Typography, { variant: "h6", component: "div", sx: { flexGrow: 1 }, children: "QuantFlow" }), _jsx(Link, { component: RouterLink, to: "/", color: "inherit", underline: "none", children: "Home" })] }) }), _jsx(Container, { component: "main", maxWidth: "xs", children: _jsx(Box, { sx: {
                        mt: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }, children: _jsxs(Paper, { elevation: 3, sx: { p: 4, width: '100%' }, children: [_jsx(Typography, { component: "h1", variant: "h5", align: "center", gutterBottom: true, children: "Sign In" }), error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: error })), statusMessage && (_jsx(Alert, { severity: "info", sx: { mb: 2 }, children: statusMessage })), _jsx(Button, { fullWidth: true, variant: "contained", startIcon: _jsx(GoogleIcon, {}), onClick: handleGoogleSignIn, disabled: loading, sx: { mb: 3 }, children: loading ? _jsx(CircularProgress, { size: 24 }) : 'Sign in with Google' }), _jsx(Divider, { sx: { my: 2 }, children: "OR" }), _jsxs("form", { onSubmit: handleLogin, children: [_jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "email", label: "Email Address", name: "email", autoComplete: "email", autoFocus: true, value: email, onChange: function (e) { return setEmail(e.target.value); }, disabled: loading }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: "Password", type: "password", id: "password", autoComplete: "current-password", value: password, onChange: function (e) { return setPassword(e.target.value); }, disabled: loading }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3 }, disabled: loading, children: loading ? _jsx(CircularProgress, { size: 24 }) : 'Sign In' })] })] }) }) })] }));
}
